import script from "./Reportes.vue?vue&type=script&setup=true&lang=js"
export * from "./Reportes.vue?vue&type=script&setup=true&lang=js"

import "./Reportes.vue?vue&type=style&index=0&id=37512364&scoped=true&lang=css"
import "./Reportes.vue?vue&type=style&index=1&id=37512364&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37512364"]])

export default __exports__